var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.5 18.25h-2.25v-15.9c0-1.125-0.975-2.1-2.1-2.1h-6.3c-1.125 0-2.1 0.975-2.1 2.1v15.9h-2.25c-0.225 0-0.375 0.15-0.375 0.375v0.75c0 0.225 0.15 0.375 0.375 0.375h15c0.225 0 0.375-0.15 0.375-0.375v-0.75c0-0.225-0.15-0.375-0.375-0.375zm-8.55-8.7c0-0.075 0.075-0.15 0.225-0.15s0.225 0 0.3 0.075l0.825 0.825 1.95-1.95c0.075-0.075 0.225-0.075 0.375-0.075 0.075 0.075 0.15 0.225 0.15 0.3l-1.575 4.8c0 0.075-0.075 0.15-0.225 0.15h-0.075c-0.075 0-0.15 0-0.225-0.075l-0.825-0.825-1.95 1.95c-0.075 0.075-0.15 0.075-0.225 0.075s-0.075 0-0.15-0.075c-0.15 0-0.225-0.15-0.15-0.225l1.575-4.8zm-2.7-7.2c0-0.3 0.3-0.6 0.6-0.6h6.3c0.3 0 0.6 0.3 0.6 0.6v2.4h-7.5v-2.4z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationIcon);
export default __webpack_public_path__ + "static/media/stationIcon.7288e4add38f64e55e068824904ae81f.svg";
export { ForwardRef as ReactComponent };